import { render, staticRenderFns } from "./createDropSuccess.vue?vue&type=template&id=65f24b77&scoped=true"
import script from "./createDropSuccess.vue?vue&type=script&lang=js"
export * from "./createDropSuccess.vue?vue&type=script&lang=js"
import style0 from "./createDropSuccess.vue?vue&type=style&index=0&id=65f24b77&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f24b77",
  null
  
)

export default component.exports